import Container from "@/components/base/Container";
import Button from "@/components/base/Button";

export default function CtaSection() {
  return (
    <section className="relative overflow-hidden bg-primary-950">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20a%20modern%20white%20logistics%20truck%20driving%20on%20an%20open%20road%20at%20golden%20hour%20with%20deep%20blue%20sky%2C%20professional%20corporate%20transport%20photography%2C%20cool%20blue%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1920&height=900&seq=axonia-cta-01&orientation=landscape"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/90 to-primary-900/70"></div>

      <Container className="relative py-16 md:py-24">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-50/10 px-3.5 py-1.5 text-xs font-label font-semibold uppercase tracking-[0.18em] text-accent-300">
            <i className="ri-flashlight-line text-sm leading-none" aria-hidden="true"></i>
            Respuesta rápida
          </span>
          <h2 className="mt-5 text-2xl font-heading font-bold text-balance text-primary-50 md:text-4xl">
            ¿Listo para mover tu carga o tu equipo?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-primary-100 md:text-base">
            Cuéntanos qué necesitas y te ayudamos a elegir la unidad adecuada. Sin complicaciones y
            con asesoría incluida.
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <Button to="/solicitar-servicio" variant="primary" size="lg" icon="ri-send-plane-line">
              Solicitar servicio
            </Button>
            <Button
              href="tel:+51987654321"
              variant="outline"
              size="lg"
              icon="ri-phone-line"
              className="border-primary-50/40 text-primary-50 hover:bg-primary-50/10 hover:border-primary-50/60"
            >
              Llamar ahora
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}